import { Dispatch, SetStateAction } from 'react'
import ModalContainer from 'components/ModalContainer'
import PrimaryButton from 'components/primaryButton'
import { MembershipTag } from 'components/Tag'
import { NewCardButton } from 'components/CardButtons'
import { useNavigate } from 'react-router-dom'

interface AvailableBalanceModalProps {
  isVisible: boolean
  setIsVisible: Dispatch<SetStateAction<boolean>>
}

const AvailableBalanceModal = ({
  isVisible,
  setIsVisible
}: AvailableBalanceModalProps) => {
  const navigate = useNavigate()

  return (
    <ModalContainer
      isShown={isVisible}
      setModalFunction={setIsVisible}
      noCloseButton
      title='¿Por qué mi monto de retiro es menor a mi monto total?'
    >
      <div className='leading-5 font-medium space-y-6 mb-4'>
        <p>Podés transferir todo el dinero que hayas ingresado a tu cuenta. </p>
        <p>
          El dinero que recibas como adelantos está destinado a usarse con la
          tarjeta de Wayni en donde quieras para realizar compras.
        </p>
        <p>
          Si necesitás tener efectivo de los adelantos podés pasar por extra
          cash para sacar dinero en comercios habilitados.
        </p>
      </div>
      <NewCardButton
        badge={
          <MembershipTag
            className='absolute z-1 !py-0'
            text='Beneficio Wayni+'
          />
        }
        className='shadow-none !py-3 !my-6'
        onClick={() => navigate('/extraer-dinero')}
      >
        <span className='text-purple-900 font-bold text-xs'>
          Extraer dinero
        </span>
      </NewCardButton>
      <PrimaryButton
        buttonText='¡Entendido!'
        primaryButtonFunction={() => setIsVisible(false)}
      />
    </ModalContainer>
  )
}

export default AvailableBalanceModal
